import { Navigate } from 'react-router'

import {
  NewActioningAction,
  NewCampaignAction,
} from '@/components/header/actions'
import { withNamespaces } from '@/i18n/route-namespaces'

export const campaignModuleRoutes = {
  path: 'campaign-module',
  children: [
    {
      index: true,
      element: <Navigate to="templates" />,
    },
    {
      path: 'templates',
      lazy: withNamespaces(['campaignModule'], async () => {
        const { CampaignModuleTemplates } = await import(
          '@/pages/campaign-module/templates'
        )

        return { Component: CampaignModuleTemplates }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['campaignModule'], async () => {
            const { CampaignModuleTemplatesList } = await import(
              '@/pages/campaign-module/templates/list'
            )

            return { Component: CampaignModuleTemplatesList }
          }),
          handle: {
            title: 'campaignModule.templates.title',
          },
        },
      ],
    },
    {
      path: 'actionings',
      lazy: withNamespaces(['campaignModule'], async () => {
        const { CampaignModuleActionings } = await import(
          '@/pages/campaign-module/actionings'
        )

        return { Component: CampaignModuleActionings }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['campaignModule'], async () => {
            const { CampaignModuleActioningsList } = await import(
              '@/pages/campaign-module/actionings/list'
            )

            return { Component: CampaignModuleActioningsList }
          }),
          handle: {
            title: 'campaignModule.actionings.metadata',
            action: <NewActioningAction />,
          },
        },
      ],
    },
    {
      path: 'campaigns',
      lazy: withNamespaces(['campaignModule'], async () => {
        const { CampaignModuleCampaigns } = await import(
          '@/pages/campaign-module/campaigns'
        )

        return { Component: CampaignModuleCampaigns }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(
            ['campaignModule', 'integrations', 'members'],
            async () => {
              const { CampaignModuleCampaignsList } = await import(
                '@/pages/campaign-module/campaigns/list'
              )

              return { Component: CampaignModuleCampaignsList }
            },
          ),
          handle: {
            title: 'campaignModule.campaigns.metadata',
            action: <NewCampaignAction />,
          },
        },
      ],
    },
  ],
}
